import { Modal } from "react-bootstrap";
import FlashLogo from "../../../../Images/FlashLogo.png";
import GradientButton from "../../../Core/GradientButton";

export default function FlashAccountPaymentCodeModal({ show, payment, onClose }) {
	return (
		<Modal show={show} onHide={onClose} centered size="lg">
			<Modal.Header>
				<div className="w-100 text-center">
					<img src={FlashLogo} alt="Flash" style={{ height: 44, width: "auto" }} />
				</div>
			</Modal.Header>
			<Modal.Body className="text-center">
				<p className="mb-2 font-weight-bold">{payment?.Package}</p>
				<div
					className="font-weight-bold"
					style={{ fontSize: "2.5rem", letterSpacing: "0.25rem", lineHeight: 1.2, color: "#009845" }}
				>
					{payment?.Code}
				</div>
				<p className="mt-3 mb-0">Show this code to the cashier at a participating Flash retailer.</p>
			</Modal.Body>
			<Modal.Footer>
				<GradientButton title="OK" variant="greenYellow" onClick={onClose} />
			</Modal.Footer>
		</Modal>
	);
}
